<template>
  <div>
    <Create :createDialog="createDialog" @close="close" :createFromStore="false" />
    <v-card class="border-r-0 elevation-0">
      <v-card-text class="pa-0">
        <v-layout row align-center >
          <v-btn flat fab small @click="$router.push({ path: '/task' })">
            <v-icon >home</v-icon>
          </v-btn>
          <span>Tasks</span>
          <v-spacer></v-spacer>
          <v-btn color="teal" flat dark @click="add">New</v-btn>
          <v-btn color="teal" flat dark @click="$router.push({ path: '/task/list' })">List</v-btn>
        </v-layout>
      </v-card-text>
    </v-card>
    <router-view></router-view>
  </div>
</template>
<script>
const Create = () => import("./components/Create");

import RegisterStoreModule from "@/mixins/RegisterStoreModule";
import taskStore from "./store.js";

export default {
  name: "task",
  data() {
    return {
      createDialog: false
    };
  },
  mixins: [RegisterStoreModule],
  created() {
    this.registerStoreModule("task", taskStore);
  },
  components: {
    Create,
  },
  methods: {
    close() {
      this.createDialog = !this.createDialog;
    },
    add() {
      this.createDialog = !this.createDialog;
    }
  }
};
</script>
